import { render, staticRenderFns } from "./emailConfig.vue?vue&type=template&id=1447fccf&scoped=true"
import script from "./emailConfig.vue?vue&type=script&lang=js"
export * from "./emailConfig.vue?vue&type=script&lang=js"
import style0 from "./emailConfig.vue?vue&type=style&index=0&id=1447fccf&prod&lang=scss&scoped=true"
import style1 from "./emailConfig.vue?vue&type=style&index=1&id=1447fccf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1447fccf",
  null
  
)

export default component.exports